import React, { Component } from "react";
import { Button } from "antd";
import "../verifyUser/verify-user.css";
import { strings } from "../../helpers/locales";
import { history } from "../../helpers";

class PageNotFoundView extends Component {
  render() {
    return (
      <div>
        <div className="verification_wrapper content-container">
          <div className="logo_wrap">
            <img src={require("../../images/kc_logo_green.png")} alt="logo" />
          </div>
          <h4 className="text-center">
            404 {strings.profile.error} - {strings.page_not_found.pageNotFound}
          </h4>
          <div className="text-center">
            <Button
              type="primary"
              size="small"
              onClick={() => {
                history.push("/");
              }}
            >
              {strings.go_home}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default PageNotFoundView;
